module.exports = __webpack_public_path__ + "static/media/setting.af816997.png";